export enum MaintenanceTableNames {
  'MaintenanceJobs' = 'MaintenanceJobs',
  'ComponentHistory' = 'ComponentHistory',
  'PerformJobSpareParts' = 'PerformJobSpareParts',
  'StandardJobTemplates' = 'StandardJobTemplates',
  'Projects' = 'Projects',
  'ExportErrors' = 'ExportErrors',
  'MarineManagerIssues' = 'MarineManagerIssues',
  'Log' = 'Log',
}
